import { getToken } from "@/utils/authHelpers";
import {API_BASE_URL} from "@/utils/api";
import axios from "axios";

export const deleteShipApi = async (shipId: string) => {
  const token = await getToken();
  if (!token) {
    throw new Error("Authorization token is required");
  }

  try {
    const response = await axios.delete(`${API_BASE_URL}/delete-ship/${shipId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting ship:", error);
    throw error;
  }
};
